import React from 'react';

const Bonuses = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11 6.83377C11 7.83377 10.6667 9.1671 9.06667 9.70043C9.53333 8.5671 9.6 7.43377 9.26667 6.3671C8.8 4.9671 7.26667 3.90043 6.2 3.30043C5.93333 3.10043 5.46667 3.3671 5.53333 3.7671C5.53333 4.50043 5.33333 5.5671 4.2 6.70043C2.73333 8.1671 2 9.70043 2 11.1671C2 13.1004 3.33333 15.5004 6 15.5004C3.33333 12.8338 5.33333 10.5004 5.33333 10.5004C5.86667 14.4338 8.66667 15.5004 10 15.5004C11.1333 15.5004 13.3333 14.7004 13.3333 11.2338C13.3333 9.1671 12.4667 7.5671 11.7333 6.63377C11.5333 6.30043 11.0667 6.50043 11 6.83377Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement("circle", { cx: "14", cy: "4.5", r: "3.5", fill: "#FF4949", stroke: "#163F48" })
);

export { Bonuses };
//# sourceMappingURL=Bonuses.js.map
